import ChatMarkdown from 'components/Chat/ChatMarkdown';
import { Button, Divider, Stack, styled } from 'shell/components';

const PromptTitleMarkdown = ({ color = 'default', text }) => {
    if (!text) return null;

    return (
        <PromptMarkdownRoot $color={color}>
            <ChatMarkdown>{text}</ChatMarkdown>
        </PromptMarkdownRoot>
    );
};

const ChatPromptDecision = ({ disabled, onSubmit, prompt, response }) => {
    const [primaryAction, secondaryAction] = prompt.options || prompt.actions || [];
    const selectedOptionId = response?.selected_option_ids?.[0] || response?.selected_action_id;
    const selectedAction = [primaryAction, secondaryAction].find(({ id } = {}) => id === selectedOptionId);

    if (!primaryAction || !secondaryAction) return null;

    if (response && selectedAction) {
        return (
            <CompletedPaper spacing={3}>
                <PromptTitleMarkdown color={'light'} text={prompt.prompt_text} />
            </CompletedPaper>
        );
    }

    return (
        <BasePaper spacing={5}>
            <PromptTitleMarkdown text={prompt.prompt_text} />
            <Stack divider={<Divider />} spacing={2.5}>
                <ActionButton
                    action={primaryAction}
                    disabled={disabled}
                    isSelected={selectedOptionId === primaryAction.id}
                    onAction={(action) =>
                        onSubmit({
                            messageText: action.label,
                            response: {
                                selected_action_id: action.id,
                                selected_option_ids: [action.id],
                            },
                        })
                    }
                />
                <ActionButton
                    action={secondaryAction}
                    color={'destructive'}
                    disabled={disabled}
                    isSelected={selectedOptionId === secondaryAction.id}
                    onAction={(action) =>
                        onSubmit({
                            messageText: action.label,
                            response: {
                                selected_action_id: action.id,
                                selected_option_ids: [action.id],
                            },
                        })
                    }
                />
            </Stack>
        </BasePaper>
    );
};

const ActionButton = ({ action, color, disabled, isSelected, onAction }) => (
    <Button
        sx={{ alignSelf: 'start' }}
        variant={isSelected ? 'primary' : 'borderless'}
        color={color}
        disabled={disabled}
        onClick={() => onAction(action)}
    >
        {action.label}
    </Button>
);

const PromptMarkdownRoot = styled(Stack, {
    shouldForwardProp: (prop) => prop !== '$color',
})(({ $color, theme }) => ({
    color: $color === 'light' ? theme.palette.ensightful.neutral[700] : theme.palette.ensightful.neutral[900],
    fontSize: '14px',
}));

const BasePaper = styled(Stack)(({ theme }) => ({
    border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
    boxShadow: theme.palette.ensightful.shadows[1],
    padding: theme.spacing(4),
    borderRadius: '16px',
    boxSizing: 'border-box',
    width: '100%',
}));

const CompletedPaper = styled(BasePaper)(({ theme }) => ({
    background: theme.palette.ensightful.neutral[50],
    borderColor: theme.palette.ensightful.neutral[200],
    boxShadow: 'none',
}));

export default ChatPromptDecision;
